// extracted by mini-css-extract-plugin
module.exports = {"sisPaginationWrap":"SisPagination_sisPaginationWrap__1FzgL","sisPagination":"SisPagination_sisPagination__zn5HJ","active":"SisPagination_active__aDjnf"};